/* Corporate gift packs driver for sections/rlc-gift-packs.liquid.
 *
 * Quantity comes from a 5-20 <select>; each <option> carries its price labels,
 * tier and nudge text (computed in Liquid), so no pricing logic lives here.
 *
 * Add flow: reserve exactly N random coins under one token
 * (POST {proxy}/coin-reserve-random, body { token, qty }), then add N units of
 * the Standard Coin variant as ONE cart line carrying _reservation_token, and
 * open the cart drawer. The server clamps qty at its cap and can hold fewer on
 * short stock, so anything other than reserved_count === N is released
 * (qty 0) and reported on the page instead of silently adding fewer coins.
 *
 * Tokens must be bare UUID v4 (the edge function rejects prefixes).
 */
(function () {
  'use strict';

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  function track(name, props) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, props || {});
    } catch (e) {}
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        return { ok: r.ok, data: data || {} };
      });
    });
  }

  function initOrder(root, form) {
    var proxy = form.getAttribute('data-proxy') || '/apps/coin-lookup';
    var variantId = Number(form.getAttribute('data-variant-id'));
    var template = form.getAttribute('data-label-template') || 'Add [count] coins to cart';
    var sel = form.querySelector('[data-gp-qty]');
    var btn = form.querySelector('[data-gp-atc]');
    var errBox = form.querySelector('[data-gp-error]');
    var countEl = form.querySelector('[data-gp-count]');
    var finalEl = form.querySelector('[data-gp-final]');
    var wasEl = form.querySelector('[data-gp-was]');
    var metaEl = form.querySelector('[data-gp-meta]');
    var nudgeEl = form.querySelector('[data-gp-nudge]');
    var tiers = [].slice.call(form.querySelectorAll('[data-gp-tier]'));
    var busy = false;

    /* The selected <option> carries every price label, computed in Liquid. */
    function selected() {
      return sel && sel.selectedIndex > -1 ? sel.options[sel.selectedIndex] : null;
    }

    function labelFor(n) { return template.replace('[count]', n); }

    function render() {
      var o = selected();
      if (!o) return;
      var n = o.value;
      if (countEl) countEl.textContent = n;
      if (finalEl) finalEl.textContent = o.getAttribute('data-final-label');
      if (wasEl) {
        var was = o.getAttribute('data-was-label');
        wasEl.textContent = was;
        wasEl.hidden = !was;
      }
      if (metaEl) metaEl.textContent = o.getAttribute('data-meta') || '';
      if (nudgeEl) {
        var nudge = o.getAttribute('data-nudge') || '';
        nudgeEl.textContent = nudge;
        nudgeEl.hidden = !nudge;
      }
      var tier = o.getAttribute('data-tier');
      tiers.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-gp-tier') === tier); });
      if (btn && !busy) btn.textContent = labelFor(n);
    }

    function showError(msg) {
      if (!errBox) { window.alert(msg); return; }
      errBox.textContent = msg;
      errBox.hidden = false;
    }

    function clearError() {
      if (errBox) { errBox.hidden = true; errBox.textContent = ''; }
    }

    function release(token) {
      postJSON(proxy + '/coin-reserve-random', { token: token, qty: 0 }).catch(function () {});
    }

    if (sel) {
      sel.addEventListener('change', function () {
        render();
        clearError();
        track('gift_pack_selected', { pack_size: Number(sel.value) });
      });
    }

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (busy) return;
      var r = selected();
      var qty = r ? parseInt(r.value, 10) : 0;
      if (!variantId || !(qty > 0)) return;

      busy = true;
      clearError();
      btn.disabled = true;
      btn.textContent = 'Reserving your coins…';
      function restore() { busy = false; btn.disabled = false; btn.textContent = labelFor(qty); }

      var token = uuid();
      var added = false;
      try {
        var reserve = await postJSON(proxy + '/coin-reserve-random', { token: token, qty: qty });
        var held = (reserve.data && reserve.data.reserved_count) || 0;
        if (!reserve.ok || !reserve.data.success || held !== qty) {
          if (held > 0) release(token);
          showError(held > 0 && held < qty
            ? 'We could only hold ' + held + ' of ' + qty + ' coins just now. Please try again, or send us a note and we will set the order up for you.'
            : (reserve.data.message || 'We could not reserve your coins. Please try again.'));
          restore();
          return;
        }

        var add = await postJSON('/cart/add.js', {
          items: [{
            id: variantId,
            quantity: qty,
            properties: {
              _reservation_token: token,
              _reserved_at: new Date().toISOString(),
              _gift_pack: String(qty)
            }
          }],
          sections: 'cart-drawer',
          sections_url: window.location.pathname
        });
        if (!add.ok) {
          release(token);
          showError(add.data.description || add.data.message || 'We could not add your coins to the cart. Please try again.');
          restore();
          return;
        }
        added = true;

        if (window.rlcStampLanding) window.rlcStampLanding();
        track('gift_pack_added_to_cart', {
          pack_size: qty,
          value: parseFloat(r.getAttribute('data-value')) || null,
          currency: 'USD'
        });

        var store = window.Alpine && window.Alpine.store && window.Alpine.store('cartDrawer');
        var html = add.data.sections && add.data.sections['cart-drawer'];
        if (store) { if (html) store.openWith(html); else store.openFresh(); }
        else { window.location.href = '/cart'; }
        restore();
      } catch (err) {
        console.error('[RLC] gift pack add failed:', err);
        if (added) { window.location.href = '/cart'; return; }
        release(token);
        showError('Something went wrong reserving your coins. Please try again.');
        restore();
      }
    });

    render();
  }

  /* Photo slider: a scroll-snap track (native swipe on touch). Arrows wrap like
     the product page gallery; thumbnails and Left/Right keys jump to a slide.
     The scroll position is the single source of truth for the active thumb. */
  function initGallery(root) {
    var wrap = root.querySelector('[data-gp-gallery]');
    var track = wrap && wrap.querySelector('[data-gp-track]');
    var slides = track ? [].slice.call(track.children) : [];
    if (slides.length < 2) return;
    var thumbsBox = wrap.querySelector('[data-gp-thumbs]');
    var thumbs = thumbsBox ? [].slice.call(thumbsBox.querySelectorAll('.rlc-gp-thumb')) : [];
    var cur = 0;
    var ticking = false;

    function mark(i) {
      cur = i;
      thumbs.forEach(function (t, j) {
        var on = j === i;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      var t = thumbs[i];
      if (t && thumbsBox.scrollWidth > thumbsBox.clientWidth) {
        var box = thumbsBox.getBoundingClientRect();
        var r = t.getBoundingClientRect();
        thumbsBox.scrollBy({ left: r.left - box.left - (box.width - r.width) / 2, behavior: 'smooth' });
      }
    }

    function go(i) {
      var n = (i + slides.length) % slides.length;
      track.scrollTo({ left: n * track.clientWidth });
      mark(n);
    }

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== cur && i >= 0 && i < slides.length) mark(i);
      });
    }, { passive: true });

    var prev = wrap.querySelector('[data-gp-prev]');
    var next = wrap.querySelector('[data-gp-next]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
    });
    window.addEventListener('resize', function () {
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = cur * track.clientWidth;
      track.style.scrollBehavior = '';
    });
  }

  /* Mobile toggle: "Ready to Purchase" / "Request Special Pricing". CSS shows
     one side under 900px based on data-gp-active; on desktop both sides show
     and the toggle is hidden. The inquiry side wins for #corporate-inquiry
     links and for the contact form's post-back (success or errors). */
  function initToggle(root) {
    var layout = root.querySelector('[data-gp-layout]');
    var tabs = [].slice.call(root.querySelectorAll('[data-gp-tab]'));
    if (!layout || tabs.length < 2) return;

    function activate(name, opts) {
      opts = opts || {};
      layout.setAttribute('data-gp-active', name);
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-gp-tab') === name;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && opts.focus) t.focus();
      });
      if (opts.track) track('gift_page_tab', { tab: name });
    }

    function fromLocation() {
      var h = window.location.hash;
      if (h === '#corporate-inquiry' || h.indexOf('#GiftPackInquiry') === 0 || /[?&]contact_posted=/.test(window.location.search)) return 'pricing';
      if (h === '#gift-packs-order') return 'purchase';
      return null;
    }

    activate(fromLocation() || layout.getAttribute('data-gp-active') || 'pricing');
    if (root.querySelector('.rlc-gp-card .rlc-gp-msg')) activate('pricing');

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(t.getAttribute('data-gp-tab'), { track: true }); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        activate(next.getAttribute('data-gp-tab'), { focus: true, track: true });
      });
    });

    window.addEventListener('hashchange', function () {
      var t = fromLocation();
      if (t) activate(t);
    });
    /* Same-hash clicks (e.g. the hero button tapped twice) fire no hashchange. */
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href$="#corporate-inquiry"]');
      if (a) activate('pricing');
    });
  }

  function initInquiry(root) {
    var form = root.querySelector('form[id^="GiftPackInquiry-"]');
    if (!form) return;
    var ok = form.querySelector('.rlc-gp-msg[role="status"]');
    if (ok) {
      try { ok.focus({ preventScroll: true }); } catch (e) {}
      var key = 'rlc_gp_lead_' + window.location.search;
      var seen = false;
      try { seen = sessionStorage.getItem(key) === '1'; sessionStorage.setItem(key, '1'); } catch (e) {}
      if (!seen) track('lead_submitted', { form: 'gift_pack_inquiry' });
      return;
    }
    form.addEventListener('submit', function () {
      var q = form.querySelector('[name="contact[Estimated quantity]"]');
      track('lead_form_submitted', { form: 'gift_pack_inquiry', estimated_qty: q && q.value ? Number(q.value) : null });
    });
  }

  function init() {
    [].forEach.call(document.querySelectorAll('[data-rlc-gift-packs]'), function (root) {
      if (root.__rlcGiftPacks) return;
      root.__rlcGiftPacks = true;
      var form = root.querySelector('[data-gp-order-form]');
      if (form) initOrder(root, form);
      initGallery(root);
      initToggle(root);
      initInquiry(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
